<crm-auto-complete
  #bankAutoComplete
  [(value)]="selectedBank"
  (valueChange)="selectedBankChange.emit($event)"
  [isError]="isError"
  [class]="class"
  [styleClass]="styleClass"
  [suggestions]="banks"
  [inputStyle]="inputStyle"
  [virtualScroll]="true"
  [virtualScrollItemSize]="60"
  [appendTo]="appendTo"
  (completeMethod)="bankSearch.emit($event.query)">
  <ng-template
    #itemTemplate
    let-bank="item">
    <div *ngIf="toBank(bank) as bank">
      <div>
        <span [innerHTML]="highlightMatchText(bank.name || '-') | safeHtml"></span>
      </div>
      <div class="frm-color-green">
        <span [innerHTML]="highlightMatchText(bank.rcbic) | safeHtml"></span>
      </div>
    </div>
  </ng-template>
</crm-auto-complete>
